<template>
  <div>
    <CRow>
      <CCol sm="12">
        <ProductsTable
          :items="products"
          hover
          striped
          border
          small
          fixed
          caption="Productos y Servicios (Catálogo del SAT)"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ProductsTable from '../../components/configuration/fiscal-products/ProductsTable.vue'
import ws from '../../services/fiscal-products';
import store from '../../store'

export default {
  name: 'Products',
  components: { ProductsTable },
  data: function () {
		return {
            products: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.products = response.data;
    }
    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      let response = await ws.get();

      if(response.type == "success"){
        this.products = response.data;
      }
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
